enum PlanNameEnum {
  estandar = 'Estándar',
  premium = 'Prémium',
  elite = 'Élite',
}

export default PlanNameEnum;
